import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-star-rating',
  templateUrl: './star-rating.component.html',
  styleUrls: ['./star-rating.component.scss']
})
export class StarRatingComponent {
  faStar = faStar;
  @Input() rating: number = 0;
  @Input() readonly: boolean = false;
  @Output() newRatingEvent = new EventEmitter<number>();

  setRating(value: number) {
    if (this.readonly) return;
    this.rating = value;
    this.newRatingEvent.emit(value); // output send to other parent component.
  }
}
